import { map } from 'rxjs/operators';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { OcorrenciaValidacaoVO } from '../../../shared/ocorrencia-validacao.vo';
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { FileUtilsService } from '../../../shared/file-utils.service';
import { MessageChannelService, BnLoadingService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import moment from "moment";

import { RemoverAlertasService } from 'src/app/shared/services/remover-alertas.service';
import { IntegracaoService } from '../integracao.service';
import { Scr } from 'src/app/model/scr.model';

@Component({
    selector: 'app-integracao-scr-importacao',
    templateUrl: './scr-importacao.component.html',
    styleUrls: ['./scr-importacao.component.scss'],
    standalone: false
})
export class SCRImportacaoComponent implements OnInit {

  @ViewChild(BnConfirmDirective, {static: false}) bnConfirm: BnConfirmDirective;

  importacaoScrForm: UntypedFormGroup;

  file: File;
  conteudoArquivo: string|undefined;

  private enviado: boolean;

  private ocorrencias: OcorrenciaValidacaoVO[] = [];

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private bnAlertsService: BnAlertsService,
    private fileUtils: FileUtilsService,
    private messageService: MessageChannelService,
    private removerAlertasService: RemoverAlertasService,
    private loadingService: BnLoadingService,
    private service: IntegracaoService) {
  }

  ngOnInit() {
    this.createReactiveForm();
  }

   createReactiveForm() {
    this.importacaoScrForm = this.formBuilder.group({
      referencia: ['', Validators.required],
      arquivo: ['', Validators.required]
    });
  }

  onFileChange(event) {
    this.ocorrencias = [];
    this.removerAlertasService.removerTodos();
    this.conteudoArquivo = undefined;

    this.importacaoScrForm.markAsDirty();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];

      if ("text/xml" !== file.type) {
        console.log(`Arquivo não é json - ${file.type}`);
        // A mensagem abaixo não aparece se for chamada diretamente aqui
        // Acredito (jmaur) que é por estar em tratamento de evento
        // Colocá-la em um processamento assíncrono (como o setTimeout()) resolve a questão
        setTimeout(() => {
          this.limpar();
          this.bnAlertsService.alertaErro('Erro', `O arquivo ${file.name} não é XML - Ele é do tipo ${file.type}.`);
        }, 0);
        return;
      }

      this.loadingService.bloqueiaTela();
      const reader = new FileReader();
      reader.readAsText(file, "UTF-8");
      reader.onload = () => {
        let conteudo;
        if (typeof reader.result === 'string') {
          conteudo = reader.result;
        } else {
          conteudo = this.fileUtils.lerConteudo(reader);
        }

        this.service.zipEncode(conteudo).then((encode) => {
          this.conteudoArquivo = encode;
          this.importacaoScrForm.updateValueAndValidity();
          this.loadingService.liberaTela();
        });

        this.file = file;
      }
    }
  }

  onSubmit() {
    this.importacaoScrForm.disable();
    this.enviado = true;
    this.enviarArquivo();
  }

  /*importarAutomaticamente() {
    this.service.scrImportacaoAutomatica().subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Importação automática iniciada.'
      });
    });
  }

  importarReferenciaEspecifica() {
    const dtReferencia = this.importacaoScrForm.get('referencia').value;

    if (dtReferencia) {
      const referencia = moment(dtReferencia).format("YYYY-MM");

      this.service.scrImportacaoAutomaticaReferenciaEspecifica(referencia).subscribe(() => {
        this.messageService.addMessage({
          title: 'Sucesso',
          type: 'CRUD_OPERATION',
          level: messageLevel.SUCCESS,
          message: 'Importação automática iniciada.'
        });
      });
    }
    else {
      this.bnAlertsService.alertaErro('Erro', `Mês de referência não preenchido`);
    }
  }*/

  enviarArquivo() {
    this.loadingService.bloqueiaTela();

    this.ocorrencias = [];
    const msgService = this.messageService;

    const exibirMensagemSucesso = (res) => {
      console.log(`Arquivo enviado ${JSON.stringify(res)}`);

      const scr = res;
      msgService.addMessage(this.gerarMensagemSucesso(this.file, scr));
      this.loadingService.liberaTela();
      this.service.realizarPesquisa = true;
      this.router.navigate(['/integracao/scr/pesquisa']);
      this.limpar();
    };

    const exibirMensagemErro = (err) => {
      this.loadingService.liberaTela();
      this.ocorrencias = this.service.ocorrencias;
      this.limpar();
    };

    const dtReferencia = this.importacaoScrForm.get('referencia').value;
    const referencia = moment(dtReferencia).format("YYYY-MM");

    this.service.scrImportacao(referencia, this.file, this.conteudoArquivo).subscribe(exibirMensagemSucesso, exibirMensagemErro);
  }

  private gerarMensagemSucesso(file: File, scr: Scr) {
    let msgSucesso: string;

    const dtReferencia = this.importacaoScrForm.get('referencia').value;
    const referencia = moment(dtReferencia).format("YYYY-MM");

    let acao = 'importado';
    if (scr.idAnterior) {
      acao = `substituiu o anterior (de Id: ${scr.idAnterior})`
    }

    msgSucesso = `Ref: ${referencia} - Arquivo ${file.name} Id: ${scr.id} ${acao}.`;

    return {
      title: 'Sucesso',
      type: 'CRUD_OPERATION',
      level: messageLevel.SUCCESS,
      message: msgSucesso
    };
  }

  canDeactivate(): Observable<boolean> | boolean {
    console.log(this.enviado);

    if (this.enviado || this.importacaoScrForm.pristine) {
      return true;
    } else {
      // map necessario porque bnConfirm retorna string e nao boolean
      return this.verificaSePodeSair().pipe(map(res => res === 'ok'));
    }
  }

  verificaSePodeSair(): Observable<string> {
    this.bnConfirm.abrirModal();
    return this.bnConfirm.resultadoConfirm.asObservable();
  }

  limpar() {
    this.file = null;

    this.importacaoScrForm.reset();
    this.importacaoScrForm.markAsPristine();
    this.importacaoScrForm.enable();
    this.importacaoScrForm.updateValueAndValidity();

    this.enviado = false;
  }

  voltar() {
    this.router.navigate(['/integracao/scr/pesquisa']);
  }
}
